import { apiService } from '@services/api.service.ts';
import { LoginSchemaT } from '@/form/auth/login.schema.ts';
import { store } from '@/store';
import { SET_AUTH_TOKEN } from '@/store/app/auth.slice.ts';
import { IAuthResponse } from '@/form/auth/auth.type.ts';

const authService = apiService.injectEndpoints({
  endpoints: build => ({
    login: build.mutation<any, LoginSchemaT>({
      query: data => {
        return {
          url: `/users/login/`,
          method: 'POST',
          body: data
        };
      },
      transformResponse: (response: { data: IAuthResponse }, meta) => {
        if (meta?.response?.ok && response?.data?.id) {
          const token = {
            access: response?.data?.access_token,
            refresh: response?.data?.refresh_token,
            expires: response?.data?.expires
          };
          const user = {
            id: response?.data?.id,
            email: response?.data?.email,
            last_login: response?.data?.last_login,
            must_reset_password: response?.data?.must_reset_password,
            username: response?.data?.username
          };

          store.dispatch(SET_AUTH_TOKEN({ token: token, user: user }));
          return response;
        }
      }
    })
  })
});

export const { useLoginMutation } = authService;
